"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.slug = exports.position = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore
// translate-ignore

const pageId = exports.pageId = 188556328598;
const slug = exports.slug = 'guides/apps/marketplace/create-an-app-listing-setup-guide';
// translate-ignore
const navTitle = exports.navTitle = 'Create an app listing setup guide';
const name = exports.name = 'Create an app listing setup guide';
const metaDescription = exports.metaDescription = 'Learn more about creating a publicly available setup guide to include with your HubSpot Marketplace app listing.';
// translate-ignore
const position = exports.position = 2;
const toc = exports.toc = [{
  "depth": 0,
  "id": "setup-guide-requirements",
  "label": "Setup guide requirements",
  "parent": null
}, {
  "depth": 0,
  "id": "setup-guide-template",
  "label": "Setup guide template",
  "parent": null
}, {
  "depth": 1,
  "id": "setup-guide-for-%5Bapp-name%5D",
  "label": "Setup guide for [App Name]",
  "parent": "setup-guide-template"
}, {
  "depth": 2,
  "id": "install-the-app",
  "label": "Install the app",
  "parent": "setup-guide-template"
}, {
  "depth": 2,
  "id": "configure-the-app",
  "label": "Configure the app",
  "parent": "setup-guide-template"
}, {
  "depth": 2,
  "id": "use-the-app",
  "label": "Use the app",
  "parent": "setup-guide-template"
}, {
  "depth": 2,
  "id": "disconnect-the-app",
  "label": "Disconnect the app",
  "parent": "setup-guide-template"
}, {
  "depth": 2,
  "id": "uninstall-the-app",
  "label": "Uninstall the app",
  "parent": "setup-guide-template"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      em: "em",
      h2: "h2",
      ul: "ul",
      li: "li",
      h3: "h3",
      h4: "h4",
      strong: "strong",
      img: "img"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      Alert
    } = _components;
  if (!Alert) _missingMdxReference("Alert", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Create an app listing setup guide"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In order for an app to be ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/marketplace/listing-your-app",
        children: "listed"
      }), " or ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/marketplace/certification-requirements",
        children: "certified"
      }), " on the HubSpot App Marketplace, the listing must include a publicly available setup guide URL."]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["You can create separate guides for installing, configuring, using, disconnecting, and uninstalling your app, but all guides must meet the requirements and be linked to the ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Setup documentation URL"
        }), " included on your App Marketplace listing."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Setup guide requirements"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In order to be ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/marketplace/listing-your-app",
        children: "listed"
      }), " on the HubSpot App Marketplace, your app must include a setup guide that meets the following requirements:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Not hidden behind a paywall or sign-in screen."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Specific to setting up your app, i.e. you cannot link to your website homepage or knowledge base homepage."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Contains the steps to install and configure the integration."
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Learn more about the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/marketplace/app-marketplace-listing-requirements",
        children: "full requirements for listing your app"
      }), " or check out an ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://orgcharthub.com/guides/setup",
        children: "example of a listed setup guide"
      }), " from OrgChartHub."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In order to be ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/marketplace/applying-for-app-certification",
        children: "certified"
      }), " on the HubSpot Marketplace, your app must include a setup guide that meets the following requirements, in addition to the above:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Adheres to current accessibility, privacy, and GDPR standards."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Is consistent with the current version of your app and HubSpot."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Includes images. Videos are recommended, but not required."
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Includes the following information:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
            children: "What your app does."
          }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
            children: "How to install your app."
          }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
            children: "How to connect a HubSpot account to your app."
          }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
            children: "Screenshots of each step of the installation process, including the scope approval screen."
          }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
            children: "How to configure your app, once installed."
          }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
            children: "How to use your app, including both automated and manual interactions."
          }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
            children: "How to disconnect a HubSpot account from your app."
          }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
            children: "How to uninstall your app from a HubSpot account."
          }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
            children: "Potential consequences to user data from disconnecting and uninstalling your app."
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Learn more about the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/marketplace/certification-requirements",
        children: "full requirements for certifying your app"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Setup guide template"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The following template uses best practices for creating a setup guide. Using this format is not required, but the template is designed to give your app a strong probability of meeting HubSpot's requirements for both listing and certification."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Setup guide for [App Name]"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
        children: "App Name"
      }), "] integrates [", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Platform Name"
      }), "] leads and accounts with HubSpot contacts and companies, which lets users:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Description of a use case"
        }), "]"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Description of an additional use case"
        }), "]"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h4, {
      children: "Install the app"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Describe instructions to install your app and connect a HubSpot account, with visual aids for each step."
      }), "] For example:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Log in to [", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Platform Name"
        }), "]."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Navigate to ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Settings"
        }), " > ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Integrations"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Locate the [", (0, _jsxRuntime.jsx)(_components.em, {
          children: "App Name"
        }), "] card."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Include a screenshot here."
        }), "]"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Install"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Select your ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "HubSpot account"
        }), ". ", (0, _jsxRuntime.jsx)(_components.img, {
          src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/connecting-app-name-to-hubspot.png",
          alt: "A screenshot of the screen for selecting the HubSpot account to connect to the integration."
        })]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Choose Account"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Review the requested scopes on this screen. [", (0, _jsxRuntime.jsx)(_components.em, {
          children: "App Name"
        }), "] requests access to read and write contacts & companies, as well as read and edit contact & company properties."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Connect app"
        }), ". ", (0, _jsxRuntime.jsx)(_components.img, {
          src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/example-scopes-for-app-integration.png",
          alt: "A screenshot of the requested scopes for an example app"
        })]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["You will be redirected to the [", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Platform Name"
        }), "] \"Integrations\" page, and new configuration options will appear."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h4, {
      children: "Configure the app"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Describe instructions to configure your app's connection to HubSpot, including visual aids for each step."
      }), "]"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In your [", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Platform Name"
        }), "] account, navigate to ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Settings"
        }), " > ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Integrations"
        }), " > ", (0, _jsxRuntime.jsxs)(_components.strong, {
          children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
            children: "App Name"
          }), "]"]
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Toggle ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Sync direction"
        }), " to select how data will sync:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "One-way"
            }), ": [", (0, _jsxRuntime.jsx)(_components.em, {
              children: "App Name"
            }), "] will only update HubSpot."]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "Two-way"
            }), ": [", (0, _jsxRuntime.jsx)(_components.em, {
              children: "App Name"
            }), "] will keep [", (0, _jsxRuntime.jsx)(_components.em, {
              children: "Platform Name"
            }), "] and HubSpot in sync."]
          }), "\n"]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Include a screenshot here."
        }), "]"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Map your [", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Platform Name"
        }), "] lead and account fields to contact and company properties in HubSpot."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Include a screenshot here."
        }), "]"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["When ready, click to toggle the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Sync"
        }), " switch on."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Include a screenshot here."
        }), "]"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Select either ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Sync existing records"
        }), " or ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Sync only new records"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Include a screenshot here."
        }), "]"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Done"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h4, {
      children: "Use the app"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Describe how to perform basic manual and/or automated actions with your app with relevant visual aids."
      }), "] For example:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
        children: "App Name"
      }), "] automatically keeps your [", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Platform Name"
      }), "] leads and accounts synced with your HubSpot contacts and companies, according to the settings configured in the previous section. Syncs run at least every 5 minutes. No manual actions are required."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h4, {
      children: "Disconnect the app"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Describe instructions to disconnect a HubSpot account from your app, including visual aids for each step. You should also describe how disconnecting affects users' HubSpot accounts and data."
      }), "] For example:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: [(0, _jsxRuntime.jsx)(_components.strong, {
        children: "Note"
      }), ": If you disconnect your HubSpot account from [", (0, _jsxRuntime.jsx)(_components.em, {
        children: "App Name"
      }), "], [", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Platform Name"
      }), "] lead & account data will no longer sync to HubSpot contacts & companies and vice versa. Existing data will remain on your HubSpot records."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Log in to [", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Platform Name"
        }), "]."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Navigate to ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Settings"
        }), " > ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Integrations"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Locate the [", (0, _jsxRuntime.jsx)(_components.em, {
          children: "App Name"
        }), "] card."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Include a screenshot here."
        }), "]"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Disconnect"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Include a screenshot here."
        }), "]"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Yes, I am sure"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h4, {
      children: "Uninstall the app"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["[", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Describe instructions to uninstall your app from within a HubSpot account. You may simply link and refer to the HubSpot Knowledge Base article on this topic."
      }), "] For example:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To uninstall [", (0, _jsxRuntime.jsx)(_components.em, {
        children: "App Name"
      }), "] from your HubSpot account, follow the instructions in ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/integrations/connect-apps-to-hubspot#uninstall-an-app",
        children: "this HubSpot Knowledge Base article"
      }), "."]
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}